<template>
    <Modal name="modal-privacy-policy" extra-content-class="simple-text-modal">
        <p>A “Frente Animal” é uma organização que organiza campanhas em defesa dos animais, em particular, os explorados em pecuária. Lutamos pelos animais, pelos seus direitos e pelo seu bem-estar. Focamo-nos em mudanças legislativas, compromissos empresariais e educação pública. O teu papel aqui é fundamental. Sem ti, não conseguiremos alcançar estes objetivos.
</p>
        <br>

        <p>A possibilidade de entrar em contacto contigo e com outras pessoas que apoiam a organização é muito importante. Enviamos e-mails e mensagens e fazemos chamadas telefónicas. A angariação de fundos e o ativismo são partes integrantes da comunicação – esforçamo-nos para incentivar as pessoas a agir de acordo com os seus valores, pedindo-lhes que façam mais pelos animais.
</p>
        <br>

        <p>Duas regras a ter em conta:</p>

        <p>– Enquanto tivermos o seu consentimento, informá-lo-emos sobre como pode fazer mais pelos animais.</p>
        <p>– Pode sempre retirar o seu consentimento clicando na ligação em qualquer e-mail que enviarmos.</p>

        <br>

        <p><strong>Disposições Gerais</strong></p>
        <p>Esta política de privacidade (doravante referida como “política”) regula as regras de utilização dos sites da “Frente Animal“ (doravante referida como “nós”, “controlador de dados”, “organização”) e o armazenamento e processamento de dados pessoais (doravante referidos como “pessoa”, “sujeito de dados”).
</p>
<p>
    A recolha, processamento e armazenamento dos seus dados pessoais são regulados por esta política, pela Lei de Proteção de Dados Pessoais de Portugal e por outros atos legais.
</p>
<p>
    A política baseia-se e vigora juntamente com os atos acima mencionados e com o Regulamento Geral de Proteção de Dados (RGPD) – (UE) 2016/679.
</p>
        <br>

        <p><strong>Política de Processamento de Dados</strong></p>
        <p>Finalidades do processamento de dados:</p>
        <ul>
            <li>– Envio de newsletters e pedidos de ajuda;</li>
            <li>– Recolha e avaliação de estatísticas:</li>
            <li>– Abertura de newsletters e cliques em links;</li>
            <li>– Visitas a páginas nos sites;</li>
            <li>– Angariação de donativos e processamento de pagamentos por bens ou serviços.</li>
        </ul>

        <br>

        <p><strong>Período de Retenção de Dados</strong></p>
        <p>Os dados recolhidos são armazenados por um período ilimitado, pois são utilizados para contactar os doadores, enviar agradecimentos pelo apoio, resolver possíveis disputas, entre outros.</p>
        <br>

        <p><strong>Direitos dos Titulares dos Dados</strong></p>
        <p>A pessoa que utiliza os sistemas da “Frente Animal” tem o direito de:</p>
        <p>– Aceder às informações acumuladas sobre si;</p>
        <p>– Solicitar a correção de dados incorretos;</p>
        <p>– Solicitar a eliminação de dados;</p>
        <p>– Cancelar a subscrição clicando na ligação nos e-mails da “Frente Animal”.</p>
        <p>Para aceder, alterar ou eliminar os seus dados, por favor contacte-nos por e-mail em info@frente animal.com </p>

        <br>

        <p><strong>Cookies</strong></p>
        <p>Ao utilizar o sistema, os cookies são armazenados no seu dispositivo para os seguintes fins:
        </p>
        <p>– Funcionamento essencial do sistema;</p>
        <p>– Avaliação do tráfego no sistema;</p>
        <p>– Memorizar as suas preferências.</p>
        <p>Os cookies podem ser visualizados, apagados ou bloqueados a qualquer momento através das ferramentas do seu navegador.</p>
        <p>Os cookies mais importantes são encriptados, garantindo assim maior segurança.</p>
        <p>Ao utilizar o sistema, aceita a utilização destes cookies.</p>

        <br>

        <p><strong>Consentimento</strong></p>
        <p>Ao continuar a navegar nos sites pertencentes ao sistema, concorda com a utilização de cookies.</p>
        <p>Ao fornecer dados pessoais, as crianças com menos de 16 anos devem ter o consentimento dos pais. Caso contrário, não é permitido fornecer esses dados. Se determinarmos que uma pessoa com menos de 16 anos forneceu dados pessoais, eles serão apagados.</p>

        <br>

        <p><strong>Transferência de Dados Pessoais para Terceiros</strong></p>
        <p>O controlador de dados tem o direito de transferir informações pessoais para terceiros apenas de acordo com a legislação Portuguesa.</p>

        <br>

        <p><strong>Medidas de Segurança Adicionais</strong></p>
        <p>O sistema tem um certificado SSL instalado, o que significa que a ligação entre o seu navegador e o servidor do sistema é encriptada. Mesmo ao utilizar redes Wi-Fi não seguras, os seus dados pessoais não estarão visíveis.</p>

        <br>

        <p><strong>Disposições Finais</strong></p>
        <p>Em caso de litígios que não possam ser resolvidos por acordo mútuo, estes serão resolvidos de acordo com a legislação da Portuguesa.</p>
        <p>A “Frente Animal” reserva-se o direito de alterar esta política de privacidade.</p>

        <br>

        <p>Se tiver dúvidas, por favor contacte-nos por e-mail em <a href="mailto:info@frenteanimal.com" class="underline">info@frenteanimal.com</a></p>
    </Modal>
</template>
